import React, { useEffect, useState } from 'react';
import { systemCode, xs_idPvr, xs_isMobile, xs_languageCode } from '../../.';
import { getLabel } from '../../data/labels';
import { getConfiguration } from '../utils';
import $ from 'jquery';

export const PvrContext = React.createContext(null);

function PvrConf(props) {
	const isMobile = xs_isMobile;
	const conf = getConfiguration();
	const pvrSettings = conf.pvrs;
	const enabled = isMobile == false && xs_idPvr != null && pvrSettings != null;
	const [pvrContext, setPvrContext] = useState({
		pvrSectionEnabled : enabled,
		testLoginUserEnabled : enabled && pvrSettings != null && pvrSettings.lue,
		testDepositUserEnabled : enabled && pvrSettings != null && pvrSettings.rue,
		testPurchaseUserEnabled : enabled && pvrSettings != null && pvrSettings.tpe,
		testDepositAndPurchaseUserEnabled : enabled && pvrSettings != null && pvrSettings.trpe,
		userLoggedFromPvr : { logged : false, bonusEnabled : true },
		pvrUserToken : null,
		pvrSectionMessage : null,
		ajaxInProgress : false,
		initialized : false,
		idPvr : xs_idPvr,
		depositAmountCent : 0,
		
		init : function(){
			if(this.initialized == false){
				const sessionToken = localStorage.getItem('pvrUserToken');
				if(sessionToken != null){
					this.setAjaxInProgress(true);
					// check token
					const url = conf['api']['getUser'];
        			const params = {
        					systemCode : systemCode,
        					lingua: xs_languageCode,
        					hash: '',
        					token : sessionToken
        			};
        			$.ajax({
        	    		type: "POST",
        	    		url : url + "?" + $.param(params),
        	    		async : true,
        	    		success : (data) => {
        	    			this.setAjaxInProgress(false);
        	    			if(data != null){
        	    				data = JSON.parse(data);
    	    					const user = data;
    	    					const sessionToken = user.logged? user.sessionToken : null;
    	    					localStorage.setItem('pvrUserToken', sessionToken);
    	    					this.pvrUserToken = sessionToken;
    	    					this.userLoggedFromPvr = user;
    	    					this.initialized = true;
    	    					setPvrContext(function(prev){
    	    			    		return {
    	    			    			...prev,
    	    			    			pvrUserToken : sessionToken,
    	    			    			userLoggedFromPvr : user,
    	    			    			initialized : true
    	    			    		}
    	    			    	});
    	    				
        	    			}
        	    		},
        	    		error : (errorData) => {
        	    			this.setAjaxInProgress(false);
        					console.log(errorData);
        					this.initialized = true;
        					setPvrContext(function(prev){
	    			    		return {
	    			    			...prev,
	    			    			initialized : true
	    			    		}
	    			    	});
        	    		}	
        	       });
				}
				else{
					this.pvrUserToken = null;
					this.userLoggedFromPvr = { logged : false, bonusEnabled : true };
					this.initialized = true;
					setPvrContext(function(prev){
			    		return {
			    			...prev,
			    			userLoggedFromPvr : { logged : false, bonusEnabled : true },
			    			pvrUserToken : null,
			    			initialized : true
			    		}
			    	});
				}
			}
		},
		
		setAjaxInProgress : function(value){
			this.ajaxInProgress = value;
			setPvrContext(function(prev){
	    		return {
	    			...prev,
	    			ajaxInProgress : value
	    		}
	    	});
		},
		
		testLoginUser(username, password){
			this.setAjaxInProgress(true);
			const url = conf['api']['testLoginUserPvr'];
			const params = {
					 systemCode,
					 lingua : xs_languageCode,
					 hash : '',
					 username,
					 password,
					 isMobile
			};
			
			$.ajax({
	    		type: "POST",
	    		url : url + "?" + $.param(params),
	    		async : true,
	    		success : (data) => {
	    			this.setAjaxInProgress(false);
	    			if(data != null){
	    				data = JSON.parse(data);
	    				if(data.code == 0 && data.object != null){
	    					const user = data.object;
	    					localStorage.setItem('pvrUserToken', user.sessionToken);
	    					this.pvrUserToken = user.sessionToken;
	    					this.userLoggedFromPvr = user;
	    					setPvrContext(function(prev){
	    			    		return {
	    			    			...prev,
	    			    			pvrUserToken : user.sessionToken,
	    			    			userLoggedFromPvr : user
	    			    		}
	    			    	});
	    				}
	    				else{
	    					this.setPvrSectionMessage('error', data.description);
	    				}
	    			}
	    		},
	    		error : (errorData) => {
	    			this.setAjaxInProgress(false);
					console.log(errorData);
	    		}	
	       });
		},

		testLoginUserPvrPhysicalSelf(username, cf, idContoPvr, sysCode=systemCode){
			this.setAjaxInProgress(true);
			const url = conf['api']['testLoginUserPvrPhysicalSelf'];
			const params = {
					 systemCode:sysCode,
					 lingua : xs_languageCode,
					 hash : '',
					 username,
					 cf,
					 idContoPvr
			};
			
			$.ajax({
	    		type: "POST",
	    		url : url + "?" + $.param(params),
	    		async : true,
	    		success : (data) => {
	    			this.setAjaxInProgress(false);
	    			if(data != null){
	    				data = JSON.parse(data);
	    				if(data.code == 0 && data.object != null){
	    					const user = data.object;
	    					localStorage.setItem('pvrUserToken', user.sessionToken);
	    					this.pvrUserToken = user.sessionToken;
	    					this.userLoggedFromPvr = user;
	    					setPvrContext(function(prev){
	    			    		return {
	    			    			...prev,
	    			    			pvrUserToken : user.sessionToken,
	    			    			userLoggedFromPvr : user
	    			    		}
	    			    	});
	    				}
	    				else{
	    					this.setPvrSectionMessage('error', data.description);
	    				}
	    			}
	    		},
	    		error : (jqXHR, textStatus, errorThrown) => {
	    			this.setAjaxInProgress(false);
					this.setPvrSectionMessage('error', textStatus);
					console.log(jqXHR);
	    		}	
	       });
		},
		
		testLogoutUser : function(){
			const url = conf['api']['testLogoutUserPvr'];
			const params = {
					 systemCode,
					 lingua : xs_languageCode,
					 hash : '',
					 token : this.pvrUserToken
			};
			
			$.ajax({
	    		type: "POST",
	    		url : url + "?" + $.param(params),
	    		async : true,
	    		success : (data) => {},
	    		error : (errorData) => {}	
	       });
		   localStorage.removeItem('pvrUserToken');
		   this.pvrUserToken = null;
		   this.userLoggedFromPvr = { logged : false, bonusEnabled : true };
		   setPvrContext(function(prev){
	    		return {
	    			...prev,
	    			pvrUserToken : null,
	    			userLoggedFromPvr : { logged : false, bonusEnabled : true }
	    		}
	    	});  
		},
		
		testDepositPvr : function(testAlsoPurchase, purchaseFunction){
			this.deletePvrSectionMessage();

			if(this.depositAmountCent == 0){		
				this.setPvrSectionMessage('error', getLabel('pvr.error.no_amount'));
				return;
			}
			
			const url = conf['api']['testDepositPvr'];
			const params = {
					 systemCode,
					 lingua : xs_languageCode,
					 hash : '',
					 token : this.pvrUserToken,
					 idPvr : xs_idPvr,
					 amount : this.depositAmountCent,
					 testAlsoPurchase : testAlsoPurchase
			};
			this.setAjaxInProgress(true);
			$.ajax({
	    		type: "POST",
	    		url : url + "?" + $.param(params),
	    		async : true,
	    		success : (data) => {
	    			this.setAjaxInProgress(false);
	    			if(data != null){
	    				data = JSON.parse(data);
	    				if(data.code == 0 && data.object != null){
	    					const user = data.object;
	    					this.setPvrSectionMessage('success', getLabel('pvr.charge_success'));
	    					this.userLoggedFromPvr = user;
	    					setPvrContext(function(prev){
	    			    		return {
	    			    			...prev,
	    			    			userLoggedFromPvr : user
	    			    		}
	    			    	});
	    					if(typeof purchaseFunction === 'function'){
	    						purchaseFunction();
	    					}
	    				}
	    				else{
	    					this.setPvrSectionMessage('error', data.description);
	    				}
	    			}
	    		},
	    		error : (errorData) => {
	    			this.setAjaxInProgress(false);
	    			this.setPvrSectionMessage('error', getLabel('pvr.error.charge'));
	    		}	
	       }); 
		},
		
		getUser : function (){
			return this.userLoggedFromPvr;
		},
		
		reloadUser : function(){
			this.initialized = false;
			this.init();
		},
		
		setPvrSectionMessage : function(type, message){
			this.pvrSectionMessage = {type, message};
			setPvrContext(function(prev){
	    		return {
	    			...prev,
	    			pvrSectionMessage : {type, message}
	    		}
	    	});
		},
		
		deletePvrSectionMessage : function(){
			if(this.pvrSectionMessage != null){
				this.pvrSectionMessage = null;
				setPvrContext(function(prev){
					return {
						...prev,
						pvrSectionMessage : null
					}
				});				
			}
		},
		
		setDepositAmountCent : function(val){
			this.depositAmountCent = val;
			setPvrContext(function(prev){
				return {
					...prev,
					depositAmountCent : val
				}
			});	
		}
	});
	
	useEffect(() => {
		pvrContext.init();
	}, []);
    return (
        	<PvrContext.Provider value={pvrContext}>
        	    {props.children}
        	</PvrContext.Provider>
        );
}

export default PvrConf;